import { Component, inject } from "@angular/core";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { Support } from "@models/support";
import { SupportsService } from "@services/supports.service";
import { catchError, EMPTY, finalize, take } from "rxjs";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { DialogHeaderComponent } from "../../../../shared/components/dialog-header/dialog-header.component";
import { LoadingComponent } from "../../../../shared/components/loading/loading.component";
import { SnackBarService } from "../../../services/snack-bar.service";

@Component({
  selector: "app-new-support-dialog",
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    ButtonComponent,
    DialogHeaderComponent,
    LoadingComponent,
  ],
  templateUrl: "./new-support-dialog.component.html",
  styleUrl: "./new-support-dialog.component.scss",
})
export class NewSupportDialogComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _supportsService = inject(SupportsService);
  private readonly _snackbarService = inject(SnackBarService);
  readonly dialogRef = inject(MatDialogRef<NewSupportDialogComponent, Support>);

  loading = false;

  form = this._fb.group({
    title: ["", [Validators.required, Validators.maxLength(120)]],
    description: ["", [Validators.required]],
  });

  controls = this.form.controls;

  confirm() {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;

    const { title, description } = this.form.getRawValue();

    this.loading = true;
    this._supportsService
      .create({ title: title!, description: description! })
      .pipe(
        take(1),
        catchError((err) => {
          this._snackbarService.openSnackBar(
            err?.error?.error ?? "Não foi possível abrir o chamado.",
            "Fechar",
            "error",
          );
          return EMPTY;
        }),
        finalize(() => (this.loading = false)),
      )
      .subscribe((support) => {
        this._snackbarService.openSnackBar(
          "Chamado aberto com sucesso.",
          "Fechar",
          "success",
        );
        this.dialogRef.close(support);
      });
  }
}
